// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module--container--2lu7t","title":"style-module--title--1be8z","expansion":"style-module--expansion--1qG9w","expanded":"style-module--expanded--340Cj"};